const ignoredElements = [
    'select-empresa',
    'processador-nfse',
    'modal-novidades',
    'modal-nfse',
    'modal-boleto',
    'modal-boleto-nf-email',
    'modal-baixa-pendencia',
    'lista-boletos',
    'simple-angucomplete',
    'simple-angucomplete-alt',
    'summernote',
    'ng-include',
    'angucomplete-alt',
    'toggle',
    'variaveis-template',
    'supervisionado-helper',
    'periodo-mes-ano',
    'contas-pagar-pagas',
    'contas-receber-recebidas',
    'modal-gerar-faturas',
    'propostas-criadas-por-mes',
    'ordens-servicos-por-mes',
    'ordens-servicos-do-dia',
    'dashboard-despesa',
    'dashboard-receita',
    'fluxo-caixa',
    'saldo-do-mes',
    'periodo-ano',
    'grafico-receitas-despesas',
    'grafico-meta-realizado',
    'select-conta',
    'grafico-receitas',
    'grafico-analise-contas',
    'grafico-comparacao-sub-contas',
    'whatsapp-link',
    'ng-map',
    'custom-marker',
    'preventiva-sob-demanda',
    'modal-questionario',
];

export default ignoredElements;